export default {
  path: 'manage-user',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage User',
      component: () => import('@/views/menus/userManagement/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
